// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"66":"97ea6e7e","157":"ee7de611","256":"cb30e76e","453":"df43adc0","473":"d8a3c88b"}[chunkId] + ".chunk.js";
};